import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["keyname", "name"];
import { Block } from 'react-login-page';
import { jsx as _jsx } from "react/jsx-runtime";
export var TitleSignup = props => {
  var {
      keyname = 'title-signup',
      name
    } = props,
    elmProps = _objectWithoutPropertiesLoose(props, _excluded);
  if (!elmProps.children) {
    elmProps.children = 'Signup';
  }
  var nameBase = name || keyname;
  return /*#__PURE__*/_jsx(Block, _extends({}, elmProps, {
    keyname: nameBase
  }));
};
TitleSignup.displayName = 'Login.TitleSignup';